/**************************************************
 * Nombre:       IconoAvatarPerfil
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Avatar, Grid, Popover, Typography} from "@mui/material";
import usus from "../../../Recursos/usuario_defecto.jpg";
import {useContext, useState} from "react";
import Barra_PerfilEmergente from "../ComponentesEditables/Barra_PerfilEmergente";
import {usuarioContext} from "../../../App";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {reducirNombre} from "../../../CodigoCliente/Funciones/reducirNombre";

const IconoAvatarPerfil = ({openPerfil, setOpenPerfil, seccionesPerfil}) => {
    const {sCell} = useResponsive()
    const [elemetoPadre, setElementoPadre] = useState(null)
    const cData = useContext(usuarioContext)

    const abrir = (e) => {
        setElementoPadre(e.target)
        setOpenPerfil(true)
    }

    const cerrar = (e) => {
        setElementoPadre(null)
        setOpenPerfil(false)
    }

    return (
        <>
            <Grid
                onClick={(e) => abrir(e)}
                container
                justifyContent={'flex-end'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{cursor: 'pointer', pr: sCell ? 0 : 1}}
            >

                <Grid container size={{xs: 7, sm: 9, md: 8}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                            <Typography sx={{
                                fontSize: 12,
                                fontWeight: 600,
                                textAlign: 'right'
                            }}>{cData.usuario && cData.usuario.tipo ? cData.usuario.tipo : 'Explorador'}</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                            <Typography sx={{fontSize: 12, fontWeight: 400, textAlign: 'right', lineHeight: 1.1}}>
                                {cData.usuario.nombre ? reducirNombre({nombre:cData.usuario.nombre}) : ''}
                            </Typography>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 5, sm: 3, md: 2}} sx={{justifyContent: 'flex-end'}}>
                    <Avatar src={cData && cData.usuario.img ? cData.usuario.img : usus}
                            sx={{width: 40, height: 40}}

                    />
                </Grid>


            </Grid>

            <Popover
                open={openPerfil}
                anchorEl={elemetoPadre}
                onClose={() => cerrar()}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            boxShadow: '0px 8px 12px 0px #00000014',
                            border: 1,
                            borderColor: 'rgba(143,173,213,0.31)',
                            borderRadius: 2
                        }

                    }
                }}
            >
                <Barra_PerfilEmergente seccionesPerfil={seccionesPerfil} usuario={cData.usuario}/>
            </Popover>
        </>


    )

}
export default IconoAvatarPerfil